<template>
    <div class="news-detail">
        <!-- <div class="news-header"><img :src="content.logo"/></div>
        <div class="news-line"></div> -->
        <div class="news-content">
            <div class="title" v-if="content.contentTitle">{{content.contentTitle}}</div>
            <div class="content" v-html="content.content"></div>
        </div>
    </div>
</template>

<script>
export default {
    name:'NewsDetail',
    data(){
        return {
           content:{},
           contentId:''
        }
    },
    created(){
        this.contentId = this.$route.query.contentId;
        if(!this.$route.query.contentId){
            MessageBox.alert("缺少参数 columnId");
            return;
        }
    },
    mounted(){
        this.getNewsDetail();
    },
    methods:{
        getNewsDetail(){
            const self = this;
            this.$http.get("/bicycle/inter/newsDetail?contentId="+this.contentId).then(function(res){
                if(res.data.status != 200){
                    MessageBox.alert(res.data.errorMsg);
                }else{
                    self.content = res.data.data;
                }
            }).catch(function(error){
                console.log(error)
            });
        }
    }
}
</script>

<style scoped>
.news-detail{
    width: 1200px;
    margin: 0 auto;
    overflow: hidden;
    margin-top: 60px;
    margin-bottom: 60px;
}
.news-line{
    border-top: 2px dashed #2E3855;
    margin-bottom: 18px;
}
.news-content{
    width: 1200px;
    overflow:auto;
}
.news-content img{
    max-width: 1200px;
}
.title{
    line-height: 24px;
    font-size: 24px;
    font-weight: bold;
    margin-top: 12px;
    margin-bottom: 12px;
    text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/pages/NewsDetail.vue